<template>
  <div class="transportDeliveryOrder">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @currentChange="currentChange"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'outboundStatus'">{{
              outboundStatusData[scope.row[item.field]]
            }}</span>
            <span v-else-if="item.field === 'outboundType'">{{
              outboundTypeData[scope.row[item.field]]
            }}</span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 拷贝退货单 -->
    <copy-return v-on:getData="getData" ref="copyReturn"></copy-return>
    <!-- 拷贝销售提单 -->
    <copy-search-table v-on:getData="getData" ref="copySearchTable"></copy-search-table>
    <!-- 拷贝调拨单 -->
    <copy-transfer v-on:getData="getData" ref="copyTransfer"></copy-transfer>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/logisticsCenter/transportDeliveryOrder.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import copyReturn from './component/copyReturn';
  import copySearchTable from './component/copySearchTable';
  import copyTransfer from './component/copyTransfer';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    components: {
      SiruiTable,
      SiruiSearch,
      copyReturn,
      copySearchTable,
      copyTransfer,
    },
    name: 'transportDeliveryOrderList',
    mixins: [tableMixins],
    data() {
      return {
        footerTotalCols: { quantity: ['storageSendQuantity'] }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        load: false,
        img: './static/img/tips.png',
        query: {
          outboundNo: null,
          salesLadingNo: null,
          allotNo: null,
          outboundStorage: null,
          outboundStatus: null,
          outboundType: null,
          outboundDepartmentNo: null,
          product: null,
          outboundBusinessPerson: null,
          nameVoyageLicense: null,
          startOutboundCreateTime: null,
          endOutboundCreateTime: null,
          returnAndChangeNo: null,
          companyCode: null,
          departmentCode: null,
          distributionBatchNo: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        partnerTypeList: [], //企业类型下拉列表
        requestStatusList: [], //申请状态下拉列表
        transportDeliveryOrderTypeList: [], //授信类型下拉列表
        accountsTypeList: [], //账款类型下拉列表
        rowData: {}, //被选中的列
        companyList: [], //公司列表
        departmentList: [], //部门列表
        outboundStatusList: [
          { label: this.$t('transportDeliveryOrder.label.theSaved'), value: '1' },
          { label: this.$t('transportDeliveryOrder.label.executed'), value: '2' },
          {
            label: this.$t('transportDeliveryOrder.label.hadWithdrawn'),
            value: '3',
          },
          {
            label: this.$t('transportDeliveryOrder.label.haveDeleted'),
            value: '4',
          },
        ], //状态
        outboundStatusData: [
          '',
          this.$t('transportDeliveryOrder.label.theSaved'),
          this.$t('transportDeliveryOrder.label.executed'),
          this.$t('transportDeliveryOrder.label.hadWithdrawn'),
          this.$t('transportDeliveryOrder.label.haveDeleted'),
        ],
        outboundTypeList: [], //出库类型
        outboundTypeData: {},
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'outboundNo',
            title: 'transportDeliveryOrder.table.outboundNo',
            //sortable: true,
            visible: true,
          },
          {
            field: 'salesLadingNo',
            title: 'transportDeliveryOrder.table.salesLadingNo',
            visible: true,
          },
          {
            field: 'allotNo',
            title: 'transportDeliveryOrder.table.allotNo',
            visible: true,
          },
          //物流批次号
          {
            field: 'distributionBatchNo',
            title: '物流批次号',
            visible: true,
          },
          {
            field: 'returnAndChangeNo',
            title: 'purchaseReturn.search.returnNo',
            visible: true,
          },
          {
            field: 'outboundStatus',
            title: 'transportDeliveryOrder.table.outboundStatus',
            visible: true,
          },
          {
            field: 'outboundType',
            title: 'transportDeliveryOrder.table.outboundType',
            visible: true,
          },
          {
            field: 'outboundCreateTime',
            title: 'transportDeliveryOrder.table.outboundCreateTime',
            visible: true,
          },
          {
            field: 'validDateTo',
            title: 'transportDeliveryOrder.table.validDateTo',
            visible: true,
          },
          {
            field: 'outboundStorageNo',
            title: '仓库编码',
            visible: true,
          },
          {
            field: 'outboundStorageName',
            title: 'transportDeliveryOrder.table.outboundStorageNo',
            visible: true,
          },
          {
            field: 'productName',
            title: 'transportDeliveryOrder.table.productName',
            visible: true,
          },
          {
            field: 'nameVoyageLicense',
            title: 'transportDeliveryOrder.table.nameVoyageLicense',
            visible: true,
          },
          {
            field: 'warehouseReceiptsNo',
            title: 'transportDeliveryOrder.table.warehouseReceiptsNo',
            visible: true,
          },
          {
            field: 'storageSendQuantity',
            title: 'transportDeliveryOrder.table.storageSendQuantity',
            visible: true,
          },
          {
            field: 'companyName',
            title: 'transportDeliveryOrder.table.companyName',
            visible: true,
          },
          {
            field: 'departmentName',
            title: 'transportDeliveryOrder.table.departmentName',
            visible: true,
          },
          {
            field: 'outboundDepartmentName',
            title: '出库部门',
            visible: true,
          },
          {
            field: 'outboundBusinessPersonName',
            title: 'transportDeliveryOrder.table.outboundBusinessPersonName',
            visible: true,
          },
          {
            field: 'outboundCreateDate',
            title: 'transportDeliveryOrder.table.outboundCreateDate',
            visible: true,
          },
          {
            field: 'outboundCreatePersonName',
            title: 'transportDeliveryOrder.table.outboundCreatePerson',
            visible: true,
          },
        ],
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'outboundNo',
            name: this.$t('transportDeliveryOrder.search.outboundNo'),
            type: 'input',
            placeholder: this.$t('transportDeliveryOrder.search.outboundNoPlaceholder'),
          },
          {
            prop: 'salesLadingNo',
            name: this.$t('transportDeliveryOrder.search.salesLadingNo'),
            type: 'input',
            placeholder: this.$t('transportDeliveryOrder.search.salesLadingNoPlaceholder'),
          },
          {
            prop: 'allotNo',
            name: this.$t('transportDeliveryOrder.search.allotNo'),
            type: 'input',
            placeholder: this.$t('transportDeliveryOrder.search.allotNoPlaceholder'),
          },
          {
            prop: 'returnAndChangeNo',
            name: this.$t('purchaseReturn.search.returnNo'),
            type: 'input',
            placeholder: this.$t('purchaseReturn.search.returnNoPlaceholder'),
          },
          {
            type: 'searchTableSpec',
            prop: 'outboundStorage',
            isMultiple: true,
            name: this.$t('transportDeliveryOrder.search.outboundStorageNo'),
            searchType: 'warehouse',
          },
          {
            prop: 'outboundStatus',
            name: this.$t('transportDeliveryOrder.search.outboundStatus'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('transportDeliveryOrder.search.outboundStatusPlaceholder'),
            options: this.outboundStatusList,
          },
          {
            prop: 'outboundType',
            name: this.$t('transportDeliveryOrder.search.outboundType'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('transportDeliveryOrder.search.outboundTypePlaceholder'),
            options: this.outboundTypeList,
          },
          {
            type: 'searchTableSpec',
            prop: 'product',
            isMultiple: true,
            name: this.$t('transportDeliveryOrder.search.good'),
            searchType: 'goodsDetail',
          },
          {
            prop: 'companyCode',
            name: '公司',
            type: 'select',
            placeholder: '请选择公司',
            options: this.companyList,
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
          },
          {
            prop: 'departmentCode',
            name: '部门',
            placeholder: '请选择部门',
            type: 'select',
            options: this.departmentList,
          },
          {
            prop: 'outboundDepartmentNo',
            name: '出库部门',
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            clearable: false,
          },
          {
            type: 'searchTableSpec',
            prop: 'outboundBusinessPerson',
            isMultiple: true,
            name: this.$t('transportDeliveryOrder.search.outboundCreatePerson'),
            searchType: 'personnel',
          },
          {
            prop: 'nameVoyageLicense',
            name: this.$t('transportDeliveryOrder.search.nameVoyageLicense'),
            type: 'input',
            placeholder: this.$t('transportDeliveryOrder.search.nameVoyageLicensePlaceholder'),
          },
          {
            prop: 'startOutboundCreateTime',
            name: this.$t('transportDeliveryOrder.search.startDate'),
            type: 'startDaterangePicker',
            placeholder: this.$t('transportDeliveryOrder.search.startDatePlaceholder'),
          },
          {
            prop: 'endOutboundCreateTime',
            name: this.$t('transportDeliveryOrder.search.endDate'),
            type: 'endDaterangePicker',
            placeholder: this.$t('transportDeliveryOrder.search.endDatePlaceholder'),
          },
          {
            prop: 'distributionBatchNo',
            name: '物流批次号',
            type: 'input',
            maxlength: 30,
            placeholder: '请输入物流批次号',
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
      this.getDic();
      this.getCompany();
    },
    methods: {
      //获取公司信息
      async getCompany() {
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      // 选择公司
      searchCompanyName(val) {
        this.departmentList = [];
        this.query.departmentCode = '';
        this.getdepartmentList(val.val);
      },
      // 根据公司查询部门
      // 获取部门
      async getdepartmentList(companyCode) {
        if (companyCode) {
          let params = {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      getDic() {
        //状态
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'outgoing_type',
            tenantCode: this.userInfo.userInfo.tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.outboundTypeList = res.data.data;
              for (var item of res.data.data) {
                this.outboundTypeData[item['value']] = item['label'];
              }
            }
          });
      },
      //获取数据
      getData() {
        this.load = true;
        let query = JSON.parse(JSON.stringify(this.query));
        //const query = this.$refs.siruiSearch.query;
        query.tenant_code = this.userInfo.userInfo.tenant_code;
        // query = this.$baseRequest.assignObj(query);
        //仓库
        if (query.outboundStorage && query.outboundStorage.length > 0) {
          query.outboundStorageNo = query.outboundStorage[0].storageCode;
        } else {
          query.outboundStorageNo = null;
        }
        //商品
        if (query.product && query.product.length > 0) {
          // query.productNo = query.product[0].productDetailCode;
          query.productNo =
            query.product && query.product[0]
              ? query.product[0].allProductDetailCode
                ? query.product[0].allProductDetailCode
                : query.product[0].productDetailCode
              : '';
        } else {
          query.productNo = null;
        }
        //业务员
        if (query.outboundBusinessPerson && query.outboundBusinessPerson.length > 0) {
          query.outboundBusinessPersonNo = query.outboundBusinessPerson[0].id;
        } else {
          query.outboundBusinessPersonNo = null;
        }
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.load = true;
        this.$axios.post(API.TRANSPORTDELIVERYORDER_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
        // console.log(row);
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        // let flag = null;
        //拷贝销售提单
        if (type === 'copySalesBill') {
          //拷贝销售提单
          this.$refs.copySearchTable.defaultVisible = true;
        } else if (type === 'copyRequisition') {
          //拷贝调拨单
          this.$refs.copyTransfer.defaultVisible = true;
        } else {
          this.$refs.copyReturn.openDialog(true);
        }
        //this.add(flag)
      },
      //新增
      add(flag) {
        let path = {
          path: '/logistics/transportDeliveryOrderAdd',
          name: 'transportDeliveryOrderAdd',
          meta: {
            keepAlive: true,
            title: this.$t('transportDeliveryOrder.label.logisticsAdded'),
          },
          query: { flag: flag, no: '2325566', type: 0 }, //type 0:新增
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //删除
      del() {
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            //TODO调用接口
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            //如果有错误返回，提示信息
            // this.$alert("我是错误信息");
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/logistics/transportDeliveryOrderDetail',
          name: 'transportDeliveryOrderDetail',
          meta: {
            keepAlive: false,
          },
          query: {
            outboundNo: value.row.outboundNo,
            flag:
              value.row.outboundType === 'CK01'
                ? '0'
                : value.row.outboundType === 'CK02'
                ? '1'
                : '2',
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
